import { takeLatest, all, fork, call, put } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* activateAccount({ data, callbacks }) {
  try {
    const response = yield call(api.createSubscription, data);
    yield put(Actions.activateAccountSuccess(response.data));
    if (typeof callbacks.success === 'function') {
      yield call(callbacks.success, response.data);
    }
  } catch (error) {
    yield put(Actions.activateAccountFail(error));
    if (typeof callbacks.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchActivateAccount() {
  yield takeLatest(Actions.ACTIVATE_ACCOUNT_REQUEST, activateAccount);
}

export default function* create() {
  yield all([fork(watchActivateAccount)]);
}
